export const DELETE_REASONS = [
  { id: 'deceased', label: 'Verstorben' },
  { id: 'not_healthy', label: 'Krank' },
  { id: 'not_interested', label: 'Möchte nicht' },
  { id: 'eye_doctor', label: 'Geht zum Augenarzt' },
  { id: 'unknown', label: 'Unbekannt' },
  { id: 'other', label: 'Andere' },
];
